import { useSecureFileUrl } from "@tellescope/tanstack-query";

export interface ExistingFileImagePreviewProps {
  secureName: string;
  type?: string;
  name: string;
}

export const ExistingFileImagePreview = ({ secureName, type, name }: ExistingFileImagePreviewProps) => {
  const isImage = type?.toLowerCase().startsWith("image/") ?? false;
  const src = useSecureFileUrl(isImage ? secureName : undefined);

  if (!isImage || !src) return null;

  return <img src={src} alt={name} className="h-12 w-12 flex-shrink-0 rounded object-cover" />;
};
